<template>
    <div id="app">
        <router-view></router-view>
        <div class="common-bottom" style="display: none" v-if="showBottom">
            <p class="p1">
                <span>上海游综网络技术有限公司</span>
                <span>联系邮箱：service@steamf.cn</span>
                <span>联系地址：中国（四川）自由贸易试验区成都高新区府城大道西段399号7栋2单元14层1409号</span>
            </p>
            <a class="p2" target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">
                <span>网站备案/许可证号：沪ICP备2025111493号-3</span>
            </a>
            <a class="p2" href="https://beian.mps.gov.cn/#/query/webSearch?code=51019002006694" rel="noreferrer" target="_blank">
                <img src="./assets/jh.png" alt />
                <span>川公网安备51019002006694</span>
            </a>
        </div>
        <!-- 微信用户迁移通知 -->
        <div class="wechat-user-migrate" :class="{ bottom: $route.path === '/game' }" v-if="migrateInfo.pic" @click="handlerClickAd">
            <img :src="filterImg(migrateInfo.pic)" />
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import { getCookieToken } from '@/utils/auth.js'
import { baiduOCPCReport } from '@/http/api/baidu.js'
import { ocpc360Report } from '@/http/api/360.js'
import { getAdConfigs } from '@/http/api/common'

export default {
    name: 'App',
    computed: {
        ...mapGetters(['showBottom'])
    },
    data() {
        return {
            times: 0,
            migrateInfo: {}
        }
    },
    watch: {
        $route: {
            immediate: true,
            handler(cur) {
                const { channel, game_id, bd_vid, qhclickid } = cur.query
                const { game_id: localGameId } = cur.params
                if (channel) {
                    this.$cookies.set('steamf-gamebox-channel', channel, '24h')
                }
                // landpage页面是从query中获取游戏id
                // tg页面是从params中获取游戏id
                // 目前线上推广的页面地址landgpage，tg页面是静态化之后的地址，为了更好的过渡做个适配
                if (game_id) {
                    this.$cookies.set('box_website_game_id', game_id, '24h')
                }
                if (localGameId) {
                    this.$cookies.set('box_website_game_id', localGameId, '24h')
                }
                if (bd_vid) {
                    this.$cookies.set('bd_vid', bd_vid, '24h')
                }
                if (qhclickid) {
                    this.$cookies.set('qhclickid', qhclickid, '24h')
                }
            }
        },
        '$store.state.serverTime': {
            immediate: true,
            handler(value) {
                if (getCookieToken() && value) {
                    const is_vip = this.$Utils.judgeVipExpire()
                    this.$store.commit('setUserVipInfoIsVip', is_vip)
                }
            }
        }
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.adjustZoom)
        this.$EventBus.$off('app-dl')
    },
    mounted() {
        const device = this.$Utils.judgeDevice()
        this.initData()
        this.$store.dispatch('getDictConfigAction')
        this.$store.dispatch('getBoxProtocolVersion')
        this.$store.dispatch('authConfigAction')
        this.$store.dispatch('userClientIpAction')
        this.$store.dispatch('getServerTime', { fn: this.calcTime })
        this.$store.dispatch('indexPageDlUrl')
        if (device === 'other') {
            this.adjustZoom()
            window.addEventListener('resize', this.adjustZoom)
        }
        this.$EventBus.$on('app-dl', () => {
            this.exceDownload()
        })
        this.getAdConfigList()
    },
    methods: {
        initData() {
            if (getCookieToken()) {
                this.$store.dispatch('userBasicInfoAction')
                this.$store.dispatch('userAuthInfoAction')
                this.$store.dispatch('userVipInfoAction')
                this.$store.dispatch('userPayConfigAction')
            }
        },
        calcTime(value) {
            const work = new Worker('/static/countDownWorker.js')
            Vue.prototype.$work = work
            work.postMessage(1)
            work.addEventListener('message', this.handlerTime.bind(this, value))
        },
        handlerTime(value) {
            let initValue = 0
            if (!this.times) {
                initValue = value
            } else {
                initValue = this.$store.state.serverTime
                if (this.times == 'restart') {
                    this.times = 0
                }
            }

            this.$store.commit('setServerTime', ++initValue)
            ++this.times
            // 每隔1分钟和服务器同步一下时间
            if (this.times >= 60) {
                this.times = 'restart'
                // 判断Web页面缓存的时间和系统时间差值是否大于1秒
                const timeDiff = Math.abs(initValue * 1000 - new Date().getTime())
                if (timeDiff > 1000) {
                    console.log('timeDiff=======>', timeDiff)
                    this.$store.dispatch('getServerTime')
                }
            }
        },
        adjustZoom() {
            const body = document.body
            const devicePixelRatio = window.devicePixelRatio
            if (devicePixelRatio != 1) {
                // 计算缩放比例，确保内容完整显示
                const zoomScale = 1 / devicePixelRatio
                body.style.zoom = `${zoomScale * 100}%`
            } else {
                // 如果设备像素比 <= 1，恢复原始缩放
                body.style.zoom = `100%`
            }
        },
        validateFilename(filename) {
            const regex = /^LesuBox_(\d+\.\d+\.\d+(\.\d+)?)_([a-zA-Z0-9]+)_(\d+)\.exe$/
            return regex.test(filename)
        },
        exceDownload() {
            const { game_id: queryGameId } = this.$route.query
            const { game_id: paramGameId } = this.$route.params
            let dlLink = this.$store.state.indexDl,
                goods_id = 0,
                bd_vid = this.$cookies.get('bd_vid'),
                qhclickid = this.$cookies.get('qhclickid'),
                gameId = queryGameId || paramGameId || this.$cookies.get('box_website_game_id') || 0,
                indexDl = dlLink,
                finallyUrl = indexDl // 最终下载地址，兜底的地址

            // tg和landpage都认为是游戏详情页面
            // 游戏详情页面下载客户端特殊处理
            // 获取游戏详情页面向缓存里面设置的商品id
            if (this.$route.path.startsWith('/landpage') || this.$route.path.startsWith('/tg')) {
                try {
                    const jsonObj = JSON.parse(sessionStorage.getItem('gameIdAndGoodsId'))
                    if (jsonObj) {
                        goods_id = jsonObj[gameId] || 0
                    }
                } catch (error) {}
            }

            // 和百度相关的数据上报
            if (bd_vid) {
                const queryParams = this.$Utils.getUrlParams(window.location.href)
                let logidUrl = window.location.href
                if (!queryParams.bd_vid) {
                    logidUrl = this.$Utils.appendParametersToUrl(logidUrl, {
                        bd_vid: bd_vid
                    })
                }

                const data = [
                    {
                        logidUrl: logidUrl,
                        newType: 6
                    }
                ]
                try {
                    baiduOCPCReport(data)
                } catch (error) {}

                this.$Utils.report({ event: 'ocpc上报', event_id: 40, n2: gameId, v1: 'download', v2: bd_vid, v3: 'box_web' })
            }
            // 和360搜索推广数据上报
            if (qhclickid) {
                const data = {
                    raw: JSON.stringify({
                        data: {
                            request_time: parseInt(Date.now() / 1000),
                            data_industry: 'ocpc_ps_convert',
                            data_detail: {
                                qhclickid,
                                event: 'SITEDOWNLOAD'
                            }
                        }
                    })
                }
                ocpc360Report(data)
            }

            // 处理下载地址
            let LesuBoxStrIndex = indexDl.indexOf('/steamf/'),
                filename = indexDl.slice(LesuBoxStrIndex + 8).slice(0, -4),
                targetBDVID = `BDVID${bd_vid}`, // 百度原始bd_vid前面加上BDVID，给客户端区分使用的
                targetQHCLICKID = `QHCLICKID${qhclickid}` // 360原始qhclickid前面加上QHCLICKID，给客户端区分使用
            try {
                const downloadParams = this.$Utils.getUrlParams(indexDl)
                if (downloadParams.n) {
                    // 有n参数，不做任何处理
                } else {
                    if (bd_vid && qhclickid) {
                        // 两个参数都存在，安装包名称不拼接相关参数
                    } else if (bd_vid) {
                        // 在BDVID后面添加game_id
                        if (gameId) {
                            targetBDVID = `${targetBDVID}@${gameId}`
                        }
                        // 地址上有无商品id
                        if (goods_id > 0) {
                            filename = `${filename}_${goods_id}_${targetBDVID}`
                        } else {
                            filename = `${filename}_${targetBDVID}`
                        }
                    } else if (qhclickid) {
                        // 在QHCLICKID后面添加qhclickid
                        if (gameId) {
                            targetQHCLICKID = `${targetQHCLICKID}@${gameId}`
                        }
                        // 地址上有无商品id
                        if (goods_id > 0) {
                            filename = `${filename}_${goods_id}_${targetQHCLICKID}`
                        } else {
                            filename = `${filename}_${targetQHCLICKID}`
                        }
                    } else {
                        // 地址上有无商品id
                        if (goods_id > 0) {
                            filename = `${filename}_${goods_id}`
                        }
                    }

                    finallyUrl = `${indexDl}?n=${filename}.exe`
                }
            } catch (error) {
                console.log('error=======>', error)
            }

            console.log('finallyUrl=======>', finallyUrl)
            window.open(finallyUrl, '_self', 'noopener,noreferrer')
        },
        filterImg(value) {
            return this.$Utils.filterImgUrl(value)
        },
        // 获取右下角微信用户迁移通知的广告
        getAdConfigList() {
            getAdConfigs({ page: 1, size: 4, platform: 'box_family', type: 19, is_enable: 1 })
                .then((res) => {
                    if (res.code === 200 && Array.isArray(res.data.list)) {
                        const firstAd = res.data.list[0]
                        if (firstAd) {
                            this.migrateInfo = firstAd
                        }
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        handlerClickAd() {
            window.open(this.migrateInfo.link, '_blank', 'noopener,noreferrer')
        }
    }
}
</script>
<style>
body {
    background: #111a20 url(/static/imgs/bg.webp) top center no-repeat;
    overflow-y: auto;
    overflow-x: hidden;
}

body.vip-bg {
    background-image: url(static/imgs/vip-bg.jpg);
}

body.game-bg {
    background-image: url(/static/imgs/game-bg.jpg);
}

body.intro-bg {
    background-image: url(static/imgs/intro-bg.png);
}

/* 底部公共样式 */
.common-bottom {
    background-color: #2a2a2a;
    color: #999;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    padding: 14px 0;
    max-width: 1920px;
    margin: 0 auto;
}

.common-bottom a {
    text-decoration: none;
}

.common-bottom p {
    margin-bottom: 12px;
}

.common-bottom .p1 > span {
    user-select: text;
    margin: 0 5px;
}

.common-bottom .p2 {
    color: #999;
    margin-bottom: 0;
    margin-left: 4px;
}

.common-bottom .p2 img {
    position: relative;
    top: 2px;
}

.common-bottom .p2:hover {
    color: #ff5d23;
}

.common-bottom .p3 {
    margin-bottom: 12px;
}

.common-bottom .p3 a {
    color: #fff;
}

.common-bottom .p3 a:hover {
    color: #ff5d23;
}

#app {
    height: 100%;
}

.wechat-user-migrate {
    position: fixed;
    width: 158px;
    height: 119px;
    right: 69px;
    bottom: 250px;
    z-index: 90;
    cursor: pointer;
}

.wechat-user-migrate.bottom {
    bottom: 30px;   
}
</style>
